import showSharingDialog from './components/SharingDialogView';
import { SharingDialogResponse } from './types/SharingDialogResponse';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

/**
 * Creates and opens the link settings dialog and returns back a promise that resolves
 * when user selects a link else it would reject.
 */
export default function sharingDialog(
    webUrl: string,
    canonicalUrl: string,
    shareId: string | null,
    permissionLevel: AttachmentPermissionLevel
): Promise<SharingDialogResponse> {
    return new Promise<SharingDialogResponse>((resolve, reject) => {
        showSharingDialog(resolve, reject, webUrl, canonicalUrl, shareId, permissionLevel);
    });
}
